import { getMobileOperatingSystem } from './getMobileOperatingSystem'

export const appCallbackHandler = (functionName: string, data?: any) => {
    const appBrowser = getMobileOperatingSystem()
    if (!window) return
    const dataToSend = typeof data === 'object' ? JSON.stringify(data) : data
    if (functionName === 'sendSharing') {
        if (appBrowser === 'Android') {
            window?.nativeApp.sendSharing(dataToSend)
        } else {
            const message = {
                process: 'sendSharing',
                data: dataToSend,
            }
            window?.webkit &&
                window?.webkit.messageHandlers.nativeApp.postMessage(message)
        }
    } else if (functionName === 'startMockTrading') {
        if (appBrowser === 'Android') {
            window?.nativeApp.startMockTrading()
        } else {
            const message = {
                process: 'startMockTrading',
            }
            window?.webkit &&
                window?.webkit.messageHandlers.nativeApp.postMessage(message)
        }
    } else if (functionName === 'pageIsLoaded') {
        if (appBrowser === 'Android') {
            window?.nativeApp.pageIsLoaded()
        } else {
            const message = {
                process: 'pageIsLoaded',
            }
            window?.webkit &&
                window?.webkit.messageHandlers.nativeApp.postMessage(message)
        }
    } else {
        if (appBrowser === 'Android') {
            window?.nativeApp?.setToolbarHeaderUI(dataToSend)
        } else {
            const message = {
                process: 'setToolbarHeaderUI',
                data: dataToSend,
            }
            window?.webkit &&
                window?.webkit.messageHandlers.nativeApp.postMessage(message)
        }
    }
}
